import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

export const assetSchema = yup.object({
  name: yup.string().required("Asset name is required"),
  description: yup.string().optional(),
  id_tag: yup.string().optional(),
  category_id: yup.string().optional(),
  dept_area: yup.string().optional(),
  room: yup.string().optional(),
  purchase_date: yup.string().required("Purchase date is required"),
  supplier: yup.string().optional(),
  warranty_expiration: yup.string().optional(),
  life_span: yup.number().optional().min(0, "Life span must be positive"),
  depreciation_value: yup
    .number()
    .optional()
    .min(0, "Depreciation value must be positive"),
  asset_condition: yup.string().optional(),
  unit_value: yup
    .number()
    .required("Unit value is required")
    .min(0, "Unit value must be positive"),
  quantity: yup
    .number()
    .required("Quantity is required")
    .min(1, "Quantity must be at least 1"),
  value: yup
    .number()
    .required("Value is required")
    .min(0, "Value must be positive"),
});

export const assetSchemaResolver = yupResolver(assetSchema);
